import { Pipe, PipeTransform, inject } from '@angular/core';
import { DateTimeService } from '../../../shared/services/date-time.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Pipe({
  name: 'timeAgo',
  standalone: false,
})
export class TimeAgoPipe implements PipeTransform {
  private dateTimeService = inject(DateTimeService);
  private translateService = inject(TranslateService);

  transform(sinceIso8601Date: string): string {
    if (!sinceIso8601Date) {
      return this.translateService.instant('tkey;time.never');
    } else if (moment(sinceIso8601Date).isSame(moment(), 'day')) {
      return this.translateService.instant('tkey;time.today');
    } else {
      return this.dateTimeService.parse(sinceIso8601Date).fromNow();
    }
  }
}
